module.exports = __webpack_public_path__ + "img/picture_viptk01_2.391fbc2b.png";